import { observer } from 'mobx-react'
import { FC, useContext, useState } from 'react'
import { useHistory } from 'react-router-dom'
import RedirectDialog from '../../../components/dialogs/RedirectDialog'
import { AppRoutingPath } from '../../../configs/routes.config'
import ConfirmOrderDialog from '../../../components/dialogs/ConfirmOrderDialog'
import AddNoteDialog from '../../../components/dialogs/AddNoteDialog'
import produce from 'immer'
import { toJS } from 'mobx'
import { useEditTransactionHelper, usePostTransactionHelper } from '../../../hooks/api'
import { transactionRecordMapper } from '../../../services/mappers'
import { v4 } from 'uuid'
import { AccountStoreContext } from '../../../stores/AccountStore'
import { ReturningType, TransactionStatus } from '../../../services/api/types'
import useTransactionForm from '../../../hooks/useTransactionForm'
import { convertToDateString } from 'src/services/formatters'

const Returning_3: FC<unknown> = () => {
  const history = useHistory()
  const [confirmReturning, setConfirmReturning] = useState(true)
  const [addNoteDialog, setAddNoteDialog] = useState(false)
  const [redirect, setRedirect] = useState(false)
  const { user } = useContext(AccountStoreContext)
  const { formStepsStore, isEditMode, matchedTransactionId } =
    useTransactionForm('returning')
  const [addNote, setAddNote] = useState<string | undefined>(
    formStepsStore.formData.information.note
  )
  const newTransaction = usePostTransactionHelper({
    onSuccess: () => {
      setConfirmReturning(false)
      formStepsStore.resetFormData()
      setRedirect(true)
    },
  })

  const editTransaction = useEditTransactionHelper({
    onSuccess: () => {
      setConfirmReturning(false)
      formStepsStore.resetFormData()
      setRedirect(true)
    },
  })

  const {
    information: {
      customerLocation,
      packagingLocation,
      date,
      createdOn,
      location: { value: branch },
      note,
      transactieType,
    },
    transaction: { rows },
  } = formStepsStore.formData

  const { mutate: mutateTransaction, isLoading: mutateTransactionLoading } = isEditMode
    ? editTransaction
    : newTransaction

  return (
    <>
      {confirmReturning ? (
        <ConfirmOrderDialog
          type={'returning'}
          isEditMode={isEditMode}
          note={formStepsStore.formData.information.note}
          isProcessing={mutateTransactionLoading}
          handleAddNoteClick={() => {
            setConfirmReturning(false)
            setAddNoteDialog(true)
          }}
          handleConfirmClick={() => {
            mutateTransaction({
              fustAantallen: rows.map(row =>
                transactionRecordMapper(row, rows, { type: transactieType })
              ),
              id: matchedTransactionId ? matchedTransactionId : v4(),
              klantnummer: toJS(user)?.customerNumber as number,
              locatie: (packagingLocation.id ? packagingLocation.id : branch) as string,
              ...(customerLocation.value.toString().length
                ? { klantLocatie: customerLocation.value.toString() }
                : null),
              status: TransactionStatus.New,
              transactieType: transactieType as ReturningType,
              datum: convertToDateString(date || new Date()),
              createdOn,
              externeNotitie: note,
            })
          }}
          handleBackClick={() => {
            setConfirmReturning(false)
            history.push(formStepsStore.skipToPreviousPath)
          }}
        />
      ) : addNoteDialog ? (
        <AddNoteDialog
          note={addNote}
          handleChangeNote={event => setAddNote(event.target.value)}
          handleCancelClick={() => {
            setAddNote(formStepsStore.formData.information.note)
            setAddNoteDialog(false)
            setConfirmReturning(true)
          }}
          handleConfirmClick={() => {
            formStepsStore.updateInformationField('note', addNote)
            setAddNoteDialog(false)
            setConfirmReturning(true)
          }}
        />
      ) : redirect ? (
        <RedirectDialog
          handleMainMenuClick={() => {
            setRedirect(false)
            history.push('/' as AppRoutingPath)
          }}
          handleTransactionClick={() => {
            setRedirect(false)
            history.push('/transactions' as AppRoutingPath)
          }}
          handleNewOrderClick={() => {
            setRedirect(false)
            history.push(formStepsStore.iterator.first() as AppRoutingPath)
          }}
        />
      ) : null}
    </>
  )
}
export default observer(Returning_3)
